import Message from './src/main.js';
export default Message;



//////////////////
// WEBPACK FOOTER
// ./package/message/index.js
// module id = null
// module chunks = 